import { FeedbackOption, PURCHASE_INTENT_OPTIONS } from './preSaleFeedbackOptions';

export const INTEREST_LEVEL_OPTIONS = PURCHASE_INTENT_OPTIONS;

export const RENT_OBJECTION_OPTIONS: FeedbackOption[] = [
  { value: 'price', label: 'Precio de renta' },
  { value: 'property_condition', label: 'Estado de la propiedad' },
  { value: 'location', label: 'Ubicación' },
  { value: 'size', label: 'Tamaño' },
  { value: 'contract_terms', label: 'Condiciones del contrato' },
  { value: 'other', label: 'Otro' },
];

export const SALE_OBJECTION_OPTIONS: FeedbackOption[] = [
  { value: 'price', label: 'Precio' },
  { value: 'property_condition', label: 'Estado de la propiedad' },
  { value: 'location', label: 'Ubicación' },
  { value: 'size_layout', label: 'Tamaño o distribución' },
  { value: 'legal_documents', label: 'Papeles/legal' },
  { value: 'other', label: 'Otro' },
];

export const ALL_GOOD = 'all_good';

export const PROPERTY_CONDITION_OPTIONS: FeedbackOption[] = [
  { value: 'cleanliness', label: 'Limpieza' },
  { value: 'maintenance', label: 'Mantenimiento' },
  { value: 'odors', label: 'Olores' },
  { value: 'lighting', label: 'Iluminación' },
  { value: 'access_parking', label: 'Acceso/parqueo' },
  { value: ALL_GOOD, label: 'Todo en orden' },
];

export const MOVE_IN_OPTIONS: FeedbackOption[] = [
  { value: 'this_week', label: 'Esta semana' },
  { value: 'this_month', label: 'Este mes' },
  { value: 'one_to_three_months', label: '1–3 meses' },
  { value: 'not_defined', label: 'Sin fecha definida' },
];

export const MAX_RECOMMENDATION = 500;
